var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('px-cancelar-dialog',{attrs:{"titulo":_vm.getTitulo,"descricao":_vm.getDescricao,"disabled":!_vm.isAberta},on:{"cancelar-dialog":_vm.onClickCancelar}})}
var staticRenderFns = []

export { render, staticRenderFns }